import type { NextPage } from 'next';
import DiscoveryComponent from '@components/expertise/discovery/discovery';
import Head from 'next/head';
import { MetaTags } from '@helpers/meta-tags.helper';
import MainLayout from '@layouts/main-layout/main-layout';
import { useRouter } from 'next/router';


const Discovery: NextPage = () => {
    let router = useRouter();
    return (
        <>
            <Head>
                {
                    MetaTags({
                        title: 'Discovery Phase from the Agilie Team',
                        description: 'Do you want your IT startup to be successful? 🚀 Order the Discovery Phase from our team! 👌 We’ll reveal the main requirements for your project and explain to you the best way to avoid main pitfalls',
                        imageUrl: '/discovery-images/discovery-phase-image-meta.png',
                    })
                }
                <link rel="icon" href="/favicon.ico"/>
            </Head>
            <MainLayout>
                <DiscoveryComponent/>
            </MainLayout>
        </>
    )
}

export default Discovery;
